import { useState, useEffect } from "react";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import BulkMessagingTab from "../../components/AdminPortal/AutoMessages/BulkMessagingTab";
import { TemplatesTab } from "../../components/AdminPortal/AutoMessages/TemplatesTab";
import { MessageLogsTab } from "../../components/AdminPortal/AutoMessages/MessageLogsTab";

const AutomatedCommunicationSystem = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const [activeTab, setActiveTab] = useState("messageLogs");
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Expose setActiveTab globally for template send functionality
  useEffect(() => {
    window.setActiveTab = (tab, template = null) => {
      setActiveTab(tab);
      if (template) {
        setSelectedTemplate(template);
      }
    };
    return () => {
      delete window.setActiveTab;
    };
  }, []);

  const renderTab = () => {
    switch (activeTab) {
      case "messageLogs":
        return <MessageLogsTab />;
      case "bulkMessaging":
        return <BulkMessagingTab preSelectedTemplate={selectedTemplate} />;
      case "templates":
        return <TemplatesTab />;
      default:
        return <MessageLogsTab />;
    }
  };

  return (
    <div
      className="min-h-screen bg-black text-white mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <header className="p-4 border-b border-gray-800">
          <h1 className="text-2xl font-light text-white-400">
            Automated Communication System
          </h1>
        </header>

        <nav className="border-b border-gray-800 overflow-x-auto">
          <ul className="flex whitespace-nowrap">
            <li
              className={`px-3 sm:px-4 py-3 cursor-pointer ${
                activeTab === "messageLogs"
                  ? "text-[#FFCA20] border-b-2 border-yellow-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("messageLogs")}
            >
              Message Logs
            </li>
            <li
              className={`px-3 sm:px-4 py-3 cursor-pointer ${
                activeTab === "bulkMessaging"
                  ? "text-[#FFCA20] border-b-2 border-yellow-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("bulkMessaging")}
            >
              Bulk Messaging
            </li>
            <li
              className={`px-3 sm:px-4 py-3 cursor-pointer ${
                activeTab === "templates"
                  ? "text-[#FFCA20] border-b-2 border-yellow-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("templates")}
            >
              Templates
            </li>
          </ul>
        </nav>

        <main className="flex-1 overflow-auto">{renderTab()}</main>
      </div>
    </div>
  );
};

export default AutomatedCommunicationSystem;
